import type { WebProfileState } from './types';

export const initialState: WebProfileState = {
  username: undefined,
  user: undefined,
  deeplink: undefined,
};

export const reducer = (state: WebProfileState = initialState) => state;
